/* eslint-disable react/jsx-one-expression-per-line */
import { ReactElement, useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import { navigateToError } from '@utils';
import { FormType } from '@constants/forms';
import { ExpandableTable } from '@components';
import { iObligation } from '@interfaces/interfaces';
import { iExtensionFormValues } from '@services/ExtensionService';
import { getObligationOptions } from '@api';
import styles from './ExtensionStep4.module.scss';

function ExtensionStep4(): ReactElement {
  const [loading, setLoading] = useState(false);
  const context = useFormikContext();
  const { values }: { values: iExtensionFormValues } = useFormikContext();

  const [authorisedOb, setObligationDetails] = useState({} as iObligation);
  const [relevantObs, setRelevantObligations] = useState([] as iObligation[]);
  useEffect(() => {
    try {
      const obNumFormIk = values.OBLIGATION_NUMBER;
      getObligationOptions(obNumFormIk, FormType.EXTENSION)
        .then((responseBody) => {
          if (responseBody && responseBody?.Authorised) {
            setObligationDetails(responseBody?.Authorised);
            context.setFieldValue('AuthorisedObligation', responseBody?.Authorised);
            context.setFieldValue('InfringementNoticeNumber', responseBody?.Authorised.InfringementNumber);
          }
          if (responseBody && responseBody?.Obligations) {
            setRelevantObligations(responseBody?.Obligations);
            context.setFieldValue('EligibleObligations', responseBody?.Obligations);
          }
        })
        .catch((e) => console.log(e));
      setLoading(false);
    } catch (ex) {
      navigateToError();
    }
    return () => {
      setLoading(false);
    };
  }, [values.OBLIGATION_NUMBER]);

  return (
    <>
      {!loading && (
        <>
          <div className="vfH2">Your fines</div>
          <p>You’re applying for an extension of time for the following fine:</p>
          <div className={styles.offenceDetails}>
            <div className={styles.detailHeadings}>
              <span>OBLIGATION NUMBER</span>
              <span>OFFENCE DATE</span>
              <span>OFFENCE DESCRIPTION</span>
              <span>AMOUNT</span>
            </div>
            <div className={styles.detailValues}>
              <span className={styles.obligationNumber}>{authorisedOb.Number}</span>
              <span>{authorisedOb.OffenceDate}</span>
              <span>{authorisedOb.OffenceDesc}</span>
              <span>${authorisedOb.AmountDue}</span>
            </div>
            <div className={styles.detailTable}>
              <table className={styles.offenceTable}>
                <tbody>
                  <tr className={styles.onlyMobileRows}>
                    <td className={styles.tdFirstColBackground}>OBLIGATION NUMBER</td>
                    <td className={styles.tdSecondColBackground}>{authorisedOb.Number}</td>
                  </tr>
                  <tr className={styles.onlyMobileRows}>
                    <td className={styles.tdFirstColBackground}>OFFENCE DATE</td>
                    <td className={styles.tdSecondColBackground}>{authorisedOb.OffenceDate}</td>
                  </tr>
                  <tr className={styles.onlyMobileRows}>
                    <td className={styles.tdFirstColBackground}>OFFENCE DESCRIPTION</td>
                    <td className={styles.tdSecondColBackground}>{authorisedOb.OffenceDesc}</td>
                  </tr>
                  <tr className={styles.onlyMobileRows}>
                    <td className={styles.tdFirstColBackground}>AMOUNT</td>
                    <td className={styles.tdSecondColBackground}>${authorisedOb.AmountDue}</td>
                  </tr>
                  <tr className={styles.hideInMobileView}>
                    <td>OFFENCE LOCATION</td>
                    <td className={styles.uppcaseText}>{authorisedOb.OffenceLocation}</td>
                  </tr>
                  <tr className={styles.hideInMobileView}>
                    <td>TIME OF OFFENCE</td>
                    <td>{authorisedOb.OffenceTime}</td>
                  </tr>
                  <tr className={styles.hideInMobileView}>
                    <td>VEHICLE REGISTRATION</td>
                    <td>{authorisedOb.Registration}</td>
                  </tr>
                  <tr className={styles.onlyMobileRows}>
                    <td colSpan={2}>OFFENCE LOCATION <br /> <span className={styles.tdSpanFont}>{authorisedOb.OffenceLocation}</span></td>
                  </tr>
                  <tr className={styles.onlyMobileRows}>
                    <td colSpan={2}>TIME OF OFFENCE <br /> <span className={styles.tdSpanFont}>{authorisedOb.OffenceTime}</span></td>
                  </tr>
                  <tr className={styles.onlyMobileRows}>
                    <td colSpan={2}>VEHICLE REGISTRATION <br /> <span className={styles.tdSpanFont}>{authorisedOb.Registration}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
            {relevantObs.length !== 0 && (
              <>
                <p>
                  <strong>Which other fines do you want to include in the application?</strong>
                </p>
                <ExpandableTable obligations={relevantObs} />
              </>
            )}
            <p className={styles.middleNoteSection}>
              This summary may not be a complete listing of your fines. Infringement information may vary as a result of a difference in:
            </p>
            <div>
              <ul>
                <li>the spelling of your name</li>
                <li>your address</li>
                <li>your driver licence number</li>
              </ul>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default ExtensionStep4;
